jQuery(function ($){

  $('.c-form__drop-input').on('change', function() {
    var value = $(this).val();
    $('.c-form__drop-block-btn-text').html(value)

  })

});